import type { LanguageId } from '../pipeline/types';

export const EXTENSION_LANGUAGE: Record<string, LanguageId> = {
  js: 'javascript',
  jsx: 'javascript',
  mjs: 'javascript',
  cjs: 'javascript',
  ts: 'typescript',
  tsx: 'typescript',
  py: 'python',
};

export function languageForPath(path: string): LanguageId | undefined {
  const ext = path.split('.').pop()?.toLowerCase();
  return ext ? EXTENSION_LANGUAGE[ext] : undefined;
}
